import React, { useCallback, useRef } from "react";
import { useLanguage } from "../../i18n";
import ProfileGridCard from "./ProfileGridCard";
import "./ProfileGridView.css";

const HEADER_COLLAPSE_DISTANCE = 110;

export default function ProfileGridView({ profiles, onProfilePress, onScrollCollapse }) {
  const { t } = useLanguage();
  const scrollRef = useRef(null);
  const collapseRafRef = useRef(null);

  const handleScroll = useCallback(() => {
    if (!onScrollCollapse) return;

    if (collapseRafRef.current) {
      window.cancelAnimationFrame(collapseRafRef.current);
    }

    collapseRafRef.current = window.requestAnimationFrame(() => {
      const el = scrollRef.current;
      if (!el) return;
      const collapse = Math.min(1, Math.max(0, el.scrollTop / HEADER_COLLAPSE_DISTANCE));
      onScrollCollapse(collapse);
    });
  }, [onScrollCollapse]);

  if (!profiles.length) {
    return (
      <div className="profile-grid-view profile-grid-view--empty" aria-live="polite">
        <p className="profile-grid-view__empty">{t("home.noProfiles")}</p>
      </div>
    );
  }

  return (
    <div
      ref={scrollRef}
      className="profile-grid-view"
      aria-label={t("home.gridView")}
      onScroll={handleScroll}
    >
      <div className="profile-grid-view__list">
        {profiles.map((profile) => (
          <ProfileGridCard
            key={profile.id}
            profile={profile}
            onClick={onProfilePress}
          />
        ))}
      </div>
    </div>
  );
}
